export default __webpack_public_path__ + "static/media/ISV.a878a3e8.svg";